import { Button } from "@mui/material";
import PrintIcon from '@mui/icons-material/Print';
import useImprimirArquivo from "../../../../../lib/useImprimirArquivo";


export default function BtnImprimirRecibo({
    numRecibo,
}: BtnImprimirReciboProps) {

    const imprimirArquivo = useImprimirArquivo()

    const handleImprimir = () => {
        imprimirArquivo("financeiro/contas-receber/imprimir-recibo/" + numRecibo + '?segunda_via=false')
    }

    return (
        <Button
            variant="contained"
            startIcon={<PrintIcon />}
            onClick={handleImprimir}
        >
            Imprimir recibo
        </Button>
    )
}

interface BtnImprimirReciboProps {
    numRecibo: number,
}
